// extracted by mini-css-extract-plugin
export default {"cBasicareBlue":"#2c2a5f","cBasicareOrange":"#e05800"};